import { Component, Input, OnInit, Output, EventEmitter} from '@angular/core';
import * as moment from 'moment';
import { PipaylibService } from 'pipaylib';
import { Cart } from 'pipaylib/domain/cart';
import { Distyconfig } from 'pipaylib/domain/distyconfig';
import { Payment } from 'pipaylib/domain/payment';
import { AppdataService } from 'src/app/services/appdata.service';
import {
  NgxQrcodeElementTypes,
  NgxQrcodeErrorCorrectionLevels,
} from '@techiediaries/ngx-qrcode';
import { Distystaff } from 'pipaylib/domain/distystaff';
import { LoadingController, ToastController } from '@ionic/angular';
import { BluetoothSerial } from '@ionic-native/bluetooth-serial/ngx';
import { Order } from 'pipaylib/domain/order';
import { Invoice } from 'pipaylib/domain/invoice';
import { Router } from '@angular/router';

@Component({
  selector: 'app-confirmrequisitionmodal',
  templateUrl: './confirmrequisitionmodal.component.html',
  styleUrls: ['./confirmrequisitionmodal.component.scss'],
})
export class ConfirmrequisitionmodalComponent implements OnInit{
  @Input() visible: boolean;
  @Input()coords: any;
  @Input() cartSummary: Cart;
  @Input() outOfStockProducts: any;
  @Input() distyconfig: Distyconfig;
  @Input() dwpallowed: any;
  @Input()frequentOrderProduct: any;
  @Output()placeOrderEmitter: EventEmitter<{
    modalVisibilty: boolean;
    confirmed?: boolean;
    isPaid?: boolean;
  }> = new EventEmitter<{
    modalVisibilty: boolean;
    confirmed?: boolean;
    isPaid?: boolean;
  }>();
  paymentObject: Payment;
  showPaymentModes: boolean;
  isConfirmed: boolean;
  paymentModes: string[] = ['Cash', 'NEFT', 'Cheque', 'UPI', 'No Payment'];
  selectedPaymentMode: string;
  placeOrderButtonDisabled: boolean;
  strsearch: string;
  showbankmodal: boolean;
  bankList: {
    name: string;
    id: string;
  }[];
  selectedBank: {
    name: string;
    id: string;
  };
  // distyconfig: Distyconfig;
  chqDate: any;
  chqNo: string;
  qrcodeimagesrc;
  elementType = NgxQrcodeElementTypes.URL;
  correctionLevel = NgxQrcodeErrorCorrectionLevels.HIGH;
  qrvalue;
  user: Distystaff;
  isLiveUpi: boolean;
  lat;
  long;
  addBankName;
  isLoading: boolean;
  addgeotag;
  showRefModal: boolean;
  upiRef: string;
  isMultiVoucher: boolean;
  vchtypes: string[];
  selectedVchtype: string;
  showVchTypes: boolean;
  orderType = '';
  nameColumns: any= [];
  macAddress;

  constructor(
    public pipaylib: PipaylibService,
    private dataService: AppdataService,
    public toastController: ToastController,
    public loadingCtrl: LoadingController,
    private bluetoothSerial: BluetoothSerial,
    private router: Router,
    public toastCtrl: ToastController,
  ) { }

  showVchTypesOnClick = () => {
    this.showVchTypes = !this.showVchTypes;
  };

  ngOnInit() {
    const staffvchs = this.pipaylib.loginService.loggedinstaff.vtypename;
    if(staffvchs && staffvchs.indexOf(',') > 0){
      this.vchtypes = staffvchs.split(',');
      this.isMultiVoucher = true;
    }else{
      this.isMultiVoucher = false;
    }
    this.placeOrderButtonDisabled = false;
    this.distyconfig = this.dataService.globalvars.get('distyconfig');
    this.paymentObject = {} as Payment;
    this.chqNo = '';
    this.isConfirmed = false;
    this.fetchQrCode();
  }

  setPipaypaymentmode() {
      const noPaymentIndex = this.paymentModes.indexOf('No Payment');
      if (noPaymentIndex !== -1) {
        this.paymentModes.splice(noPaymentIndex, 0, 'PiPay');
    }
  }

//   setPipaypaymentmode() {
//     const noPaymentIndex = this.paymentModes.indexOf('No Payment');
//     if (noPaymentIndex !== -1) {
//       this.paymentModes.splice(noPaymentIndex, 0, 'PiPay');
//   }
//    // Now, check the condition to remove 'No Payment' if necessary
//    if (this.dwpallowed == false && this.orderType === 'readystock') {
//     // Remove 'No Payment' from the array if the condition is met
//     const noPaymentIndexAfterCheck = this.paymentModes.indexOf('No Payment');
//     if (noPaymentIndexAfterCheck !== -1) {
//         this.paymentModes.splice(noPaymentIndexAfterCheck, 1); // Remove 'No Payment'
//     }
// }
// }

  setChqDate() {
    this.chqDate = moment().format('YYYY-MM-D');
    const defaultperiod =
      this.pipaylib.loginService.loggedindistributor.distyconfig
        .defaultcreditperiod;
    this.chqDate = this.pipaylib.solace.utilService.addDaystoDate(
      this.chqDate,
      defaultperiod ? defaultperiod : 0
    );
  }

  extractProductNames(products) {
    const productNames = products.map(product => product.productName);
    return productNames.join(', ');
}

  getBankList() {
    const banklist = this.pipaylib.solace.dataService.getMasterFromMap('distybank');
    this.bankList = [];
   for (const bank of banklist) { this.bankList.push({ name: bank.name, id: bank.id });}
  }

  selectVchType(vchtype: string) {
    this.pipaylib.orderService.curOrder.vchtype = vchtype;
    this.showVchTypes = false;
  }

  fetchQrCode() {
    const pn =
    this.pipaylib.loginService.loggedindistributor.businessname.replace(
      / /g,
      '+'
    );
    const pa = this.pipaylib.loginService.loggedindistributor.distyconfig.vpaid;
    this.isLiveUpi =
      this.pipaylib.loginService.loggedindistributor.distyconfig.liveupi ?? false;
    const qrlink = 'upi://pay?pn=' + pn + '&pa=' + pa + '&am=' + this.paymentObject.paidamount;
    this.user = this.pipaylib.loginService.loggedinstaff;
    this.qrvalue = qrlink;
  }


  closeRefModal() {
    setTimeout(() => {
      this.showRefModal = false;
    }, 100);
  }

  openRefModal() {
    this.showRefModal = true;
  }

  async confirmRef() {
    this.showRefModal = false;
    this.closeRefModal();
    this.saveRequisition();
  }

  onChangePaymentAmount() {
    this.fetchQrCode();
  }

  confirm(bank) {
    this.selectedBank = bank.name;
    this.closebankModal();
    this.strsearch = '';
  }

  closebankModal() {
    setTimeout(() => {
      this.showbankmodal = false;
    }, 100);
  }

  onHide() {
    this.isConfirmed = false;
    this.visible = false;
    this.selectedPaymentMode = '';
    this.showPaymentModes = true;
    this.orderType = '';
    this.placeOrderEmitter.emit({
      modalVisibilty: this.visible
    });
  }

  showPaymentModeOnClick() {
    this.showPaymentModes = !this.showPaymentModes;
  }

  openbankModal() {
    this.showbankmodal = true;
  }

  inncreaseChequeDate() {
    const curdate = this.chqDate;
    this.chqDate = this.pipaylib.solace.utilService.addDaystoDate(curdate, +1);
  }

  decreaseChequeDate() {
    const curdate = this.chqDate;
    this.chqDate = this.pipaylib.solace.utilService.addDaystoDate(curdate, -1);
  }

  onConfirm() {
    if (this.distyconfig?.paymentinorder || this.orderType === 'readystock') {
      this.isConfirmed = true;
      this.showPaymentModes = false;

      // add pipay payment mode if Auto confirm orders in the systemparameter allows it
      if (
          this.pipaylib.loginService?.loggedindistributor?.enablepipay &&
          (this.distyconfig?.autoconfirmorders || this.orderType === 'readystock')
        ) {
          this.setPipaypaymentmode();
        }
    } else {
      this.saveRequisition();
    }
    if (this.paymentModes && this.paymentModes.length > 0) {
      this.paymentObject = {} as Payment;
      this.paymentObject.paidamount = 0;
      this.selectedPaymentMode = '';
    }
  }

  validatePaymentMode() {
    switch (this.selectedPaymentMode) {
      case 'Cash':
        this.checkCashPaymentValidity();
        break;
      case 'No Payment':
        this.placeOrderButtonDisabled = false;
        break;
      case 'Cheque':
        this.checkChequePaymentValidity();
        break;
      case 'UPI':
        this.checkUpiPaymentValidity();
        break;
      case 'NEFT':
        this.checkNeftPaymentValidity();
        break;
        case 'PiPay':
          this.checkPiPayPaymentValidity();
          break;
    }
  }

  onSelectPaymentMode(paymentMode: string) {
    this.selectedPaymentMode = paymentMode;
    this.showPaymentModes = false;
    this.paymentObject.paidamount = 0;
    this.paymentObject.txnreference = '';
    this.upiRef = '';
    switch (this.selectedPaymentMode) {
      case 'Cash':
        this.checkCashPaymentValidity();
        break;
      case 'No Payment':
        this.placeOrderButtonDisabled = false;
        break;
      case 'Cheque':
        this.checkChequePaymentValidity();
        break;
      case 'UPI':
        this.checkUpiPaymentValidity();
        break;
      case 'PiPay':
        this.placeOrderButtonDisabled = false;
        break;
      case 'NEFT':
        this.checkNeftPaymentValidity();
        break;
    }
  }

  checkCashPaymentValidity() {
    this.placeOrderButtonDisabled = this.paymentObject.paidamount <= 0;
  }

  checkChequePaymentValidity() {
    this.getBankList();
    this.setChqDate();
    if (this.distyconfig?.banknameinstaffapp) {
      this.placeOrderButtonDisabled = this.paymentObject.paidamount <= 0 || !this.chqNo || this.chqNo.length !== 6 || !this.selectedBank;
    } else{
      this.placeOrderButtonDisabled = this.paymentObject.paidamount <= 0 || !this.chqNo || this.chqNo.length !== 6;
    }
  }

  checkUpiPaymentValidity() {
    this.placeOrderButtonDisabled = this.paymentObject.paidamount <= 0 || !this.upiRef || this.upiRef.length < 3;
  }

  checkNeftPaymentValidity() {
    this.placeOrderButtonDisabled = this.paymentObject.paidamount <= 0 || !this.paymentObject.txnreference;
  }

  checkPiPayPaymentValidity() {
    this.placeOrderButtonDisabled = this.paymentObject.paidamount <= 0;
    if (this.paymentObject.paidamount > this.cartSummary.payableamount) {
      this.showErrorToast('Amount cannot be more than Payable Amount');
      this.placeOrderButtonDisabled = true;
    }
  }

  async showErrorToast(errmsg){
    const toast = await this.toastCtrl.create({
      message: errmsg,
      duration: 2500,
      icon: 'close',
      color: 'danger',
    });
    toast.present();
  }

  onPlaceOrder() {
    this.visible = false;
    this.isConfirmed = false;
    this.placeOrderEmitter.emit({
      modalVisibilty: false,
      confirmed: true
    });
  }

  async saveRequisition() {
    let toast;
    this.setCoords();
    console.log('orderalert' +  this.distyconfig.orderalert);
    
    if (this.cartSummary.itemcount > 45) {
      toast = await this.toastController.create({message: 'A maximum of 45 items can be added to a requisition.', duration: 1500,
      icon: 'alert-circle-outline', color: 'danger',position: 'top'});
      toast.present();
      return;
    }
    if(this.isMultiVoucher && (!this.pipaylib.orderService.curOrder.vchtype || this.pipaylib.orderService.curOrder.vchtype.length < 2 )){
      toast = await this.toastController.create({message: 'Please select a voucher type', duration: 1500,
      icon: 'alert-circle-outline', color: 'danger',position: 'top'});
      toast.present();
      return;
    }
    if (this.selectedPaymentMode) {
      this.paymentObject.paymentmode = this.selectedPaymentMode;
    }
    if (this.selectedPaymentMode === 'Cheque') {
      this.paymentObject.bankname = this.selectedBank?.name;
      this.paymentObject.instrumentdate = this.chqDate;
      this.paymentObject.instrumentref = this.chqNo;
    } else if (this.selectedPaymentMode === 'UPI') {
      this.paymentObject.txnreference = this.upiRef;
    }
    this.showLoader('Processing...');
    if (this.distyconfig.geotagfororder) {
      if (!this.lat && !this.long) {
        toast = await this.toastController.create({
          message: 'Kindly Allow Permission To Access Location Of The Device',
          duration: 1500,
          icon: 'alert-circle-outline',
          color: 'danger',
          position: 'top',
        });
        setTimeout(() => {
          this.hideLoader();
          toast.present();
        }, 1000);
        return;
      }
    }
    let request;
    let nopayment = true;
    const isreadystock = this.orderType === 'readystock' ? true : false;
    if(this.distyconfig.paymentinorder || isreadystock) {
      nopayment = false;
    }
    if ( this.selectedPaymentMode ==='No Payment' || nopayment || this.selectedPaymentMode === 'PiPay') {
      request = await this.pipaylib.orderService.placeOrder({} as Payment,
        isreadystock, this.lat, this.long);
      if (this.selectedPaymentMode === 'PiPay') {
        let invoice;
        const invoices = await this.pipaylib.invoiceService.getDistyRetailerInvoices(
          this.pipaylib.loginService.loggedindistributor.id, request.orderobj.distyretailerid);
        if (invoices && invoices.length > 0) {
          invoice = invoices.find(inv => inv.invoicenumber === request.orderobj.billseq);
          this.placeOrderEmitter.emit({
            modalVisibilty: false,
            isPaid: true
          });
          this.dataService.globalvars.set('fromrequsition', true);
          this.hideLoader();
          setTimeout(() => {
            this.goToPipayPayment(invoice);
          }, 300);
          return;
        }
      }
    } else {
      request = await this.pipaylib.orderService.placeOrder(this.paymentObject, isreadystock, this.lat, this.long);
    }
    if (request.status === 'success') {
      if(!this.distyconfig.nostkdisplay){
         if(this.distyconfig.inventorymgmt || (this.distyconfig.accountingsystem == 'Busy' && this.distyconfig.busyconfig && this.distyconfig.busyconfig.showbusystockaslivestock)) {
            await this.pipaylib.dataService.updateDistyProducts(this.pipaylib.loginService.loggedindistributor.id);
         }else{
            let strwhid = null;
            if(this.distyconfig.multiwh ){
              if( this.pipaylib.loginService.loggedinstaff.assignedwh && this.pipaylib.loginService.loggedinstaff.assignedwh.length > 0 )
                strwhid = this.pipaylib.loginService.loggedinstaff.assignedwh[0];
            }

            await this.pipaylib.dataService.setLiveProductStock(this.pipaylib.loginService.loggedindistributor.id,strwhid);
         }
      }

      if (this.distyconfig && this.distyconfig.btprinter) {
        this.sendData(request.orderobj);
      }
      this.paymentObject = {} as Payment;
      this.chqDate = moment().format('YYYY-MM-D');
      this.chqNo = '';
      this.selectedBank = null;
      this.selectedPaymentMode = '';
      this.visible = false;
      this.orderType = '';
      this.placeOrderEmitter.emit({
        modalVisibilty: false,
        isPaid: true
      });

      if (isreadystock) {
        toast = await this.toastController.create({
          message: 'Ready Stock Created Successfully!', duration: 3000,
          icon: 'checkmark-circle-outline', color: 'success', position: 'top',});
      } else {
        toast = await this.toastController.create({
          message: 'Requisition Successfully Added!',
          duration: 3000,
          icon: 'checkmark-circle-outline',
          color: 'success',
          position: 'top',
        });
      }
      setTimeout(() => {
        this.hideLoader();
        toast.present();
      }, 300);
      this.onPlaceOrder();
    } else {
      toast = await this.toastController.create({
        message: request.errordescription,
        duration: 3000,
        icon: 'alert-circle-outline',
        color: 'danger',
        position: 'top',
      });
      setTimeout(() => { this.hideLoader(); toast.present();
      }, 1000);
    }
  }

  async goToPipayPayment(invoice: Invoice) {
    invoice.paidamount = this.paymentObject.paidamount;
    this.dataService.globalvars.set('invoiceforpipayment', invoice);
    this.dataService.globalvars.set('openpg', true);
    this.dataService.globalvars.set('pgmultiinv', false) ;
    this.router.navigate(['/pipaypayment'], { replaceUrl: true });
  }

  setCoords() {
    if (this.coords) {console.log(this.coords);
      this.lat = this.coords.latitude ; this.long = this.coords.longitude;
    } else {
      this.lat = ''; this.long = '';
    }
  }

  showLoader(msg) {
    if (!this.isLoading) {this.isLoading = true;}
    return this.loadingCtrl
      .create({
        message: msg,
        spinner: 'bubbles',
      })
      .then((res) => {
        res.present().then(() => {
          if (!this.isLoading) {
            res.dismiss().then(() => {});
          }
        });
      })
      .catch((e) => {
        this.isLoading = false;
      });
  }

  hideLoader() {
    if (this.isLoading) {
      this.isLoading = false;
    }
    return this.loadingCtrl
      .dismiss()
      .then(() => console.log(''))
      .catch((e) => console.log(e));
  }

  getMyLocation() {
    navigator.geolocation.getCurrentPosition((pos) => {
      this.long = +pos.coords.longitude;
      this.lat = +pos.coords.latitude;
    },
    (error) => {
      console.error('Error getting geolocation:', error);
    });
  }

  async sendData(ord: Order) {
    const printerSize = this.pipaylib.loginService.loggedinstaff.printersize;
    let resultByte;
    if (printerSize === '4inch' || !printerSize) {
      console.log('4inch or unassigned');
      resultByte = await this.dataService.getBTPrintBuffer(ord);
    } else {
      console.log('2inch');
      resultByte = await this.dataService.getBTPrintBuffer2inch(ord);
    }

    // const resultByte = await this.dataService.getBTPrintBuffer(ord);
    const deviceid = localStorage.getItem('blprinter');
   console.log(deviceid);
    this.bluetoothSerial.connect(deviceid).subscribe(() => {
      console.log('Connected to printer');
      this.bluetoothSerial.write(resultByte).then(() => {
        this.bluetoothSerial.clear();
        this.bluetoothSerial.disconnect();
        console.log('Print success');
      })
      .catch((err) => {
        console.error(err);
        this.bluetoothSerial.disconnect();
      });
     },
     (error) => {
       console.error('Error connecting to printer', error);
     }
   );
  }

}
